/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Toolbar_Metadata_TitleInputs */



/**
* | output |
* | --- |
* | "Iconik Asset Metadata" |
*
* @param {Iconik_Toolbar_Metadata_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_toolbar_metadata_title = /** @type {((inputs?: Iconik_Toolbar_Metadata_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Toolbar_Metadata_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Iconik Asset Metadata")
	if (locale === "de") return /** @type {LocalizedString} */ ("Iconik Asset Metadata")
	if (locale === "it") return /** @type {LocalizedString} */ ("Iconik Asset Metadata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Iconik Asset Metadata")
	if (locale === "es") return /** @type {LocalizedString} */ ("Iconik Asset Metadata")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Iconik Asset Metadata")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Iconik Asset Metadata")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Iconik Asset Metadata")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Iconik Asset Metadata")
	return /** @type {LocalizedString} */ ("Iconik Asset Metadata")
});